import { Purchases } from "@revenuecat/purchases-js";

const WEB_BILLING_PUBLIC_API_KEY =
  process.env.REACT_APP_WEB_BILLING_PUBLIC_API_KEY || "";

let purchasesInstance: Purchases | null = null;
let configuredUserId: string | null = null;

export const getPurchases = (appUserId: string): Purchases => {
  // If already configured for the same user, return existing instance
  if (purchasesInstance && configuredUserId === appUserId) {
    return purchasesInstance;
  }

  // Configure new instance (or reconfigure for different user)
  purchasesInstance = Purchases.configure({
    apiKey: WEB_BILLING_PUBLIC_API_KEY,
    appUserId: appUserId,
  });
  configuredUserId = appUserId;

  return purchasesInstance;
};

export const PRODUCT_ID = "eaziquote_web_pro_monthly";
export const OFFERING_ID = "web_welcome_99_mon";
